import { colors } from '@/theme/tokens';
import type { DeviceStatus } from '@/types';

export interface StatusVisual {
  bg: string;
  color: string;
  label: string;
}

export const deviceStatusConfig: Record<DeviceStatus, StatusVisual> = {
  online: { bg: colors.status.online.bg, color: colors.status.online.color, label: 'Online' },
  away: { bg: colors.status.online.bg, color: colors.status.online.color, label: 'Online' },
  offline: { bg: colors.status.offline.bg, color: colors.status.offline.color, label: 'Offline' },
  pending: { bg: colors.status.pending.bg, color: colors.status.pending.color, label: 'Pending' },
  blocked: { bg: colors.status.blocked.bg, color: colors.status.blocked.color, label: 'Blocked' },
};

export function getDeviceStatusConfig(status: DeviceStatus): StatusVisual {
  return deviceStatusConfig[status] ?? deviceStatusConfig.offline;
}
